import isDEClass, { VORSCHULE_ID } from './is-de-class';
import placeDEClassesIdsWithinRanges from './place-de-classes-ids-within-ranges';

// the first class found among grades is the start point of all class ranges
// Vorschule (id 17) is always placed immediately before class ranges, e.g., below
// [grd1, cls_1, cls_2, Vorschule, cls_4, grd2] -> [grd1, Vorschule, cls_1-2, cls-4, grd2]
const getDEGradesWithClassesWithinRange = (grades: MaterialClassGrade[]): string[] => {
    const allClasses = grades.filter(({ id }) => isDEClass(id));

    const hasClasses = allClasses.length > 0;

    if (!hasClasses) {
        return grades.map(({ title }) => title);
    }

    const specificClassBeforeRanges = grades.find(({ id }) => id === VORSCHULE_ID);
    const allGradesAreActuallyClasses = allClasses.length === grades.length;
    const classWordInDe = allClasses[0].title.split(' ')[1];
    const ranges = placeDEClassesIdsWithinRanges(allClasses).map((range) => `${range}. ${classWordInDe}`);

    if (allGradesAreActuallyClasses) {
        return ranges;
    }

    return grades.reduce<string[]>((result, grade) => {
        if (grade.id === specificClassBeforeRanges?.id) {
            return result;
        }

        if (!isDEClass(grade.id)) {
            result.push(grade.title);

            return result;
        }

        if (grade.id === allClasses[0].id) {
            if (specificClassBeforeRanges) {
                result.push(specificClassBeforeRanges.title);
            }

            result.push(...ranges);
        }

        return result;
    }, []);
};

export default getDEGradesWithClassesWithinRange;
